import FirmwareRequired from './firmwareRequired.jsx';
import LayoutCheckbox from '../../components/forms/layoutCheckbox.jsx';
import LayoutDatePicker from 'components/forms/layoutDatePicker';
import LayoutInput from '../../components/forms/layoutInput.jsx';
import TemperatureInput from '../../components/forms/TemperatureInput.jsx';
import LayoutSelect from '../../components/forms/layoutSelect.jsx';
import Loader from '../../components/loader.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import ToolTip, {tooltipPositions} from '../../components/ToolTip.jsx';
import TestConnectStatusBar from './testConnectStatusBar.jsx';
import TestConnectStatusBar2p0 from './testConnectStatusBar2p0.jsx';
import {balanceColumns} from '../../helpers/fieldHelpers.jsx';
import {getErrorCode} from '../../../services/errorCodes.jsx';
import {optimizerPlusTitle} from '../../helpers/dataHelpers.jsx';
import {productTypes, seasonTypes, systemTypes, winterOxidizers, countries, phosphateLevels, phosphateLevelsNames, xfName, chemicalBaseTypes} from '../../helpers/constants.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {validateTemperatureCelsius, validateTemperatureFarenheit} from '../../helpers/temperatureHelper';
import {testConnectSidebarEnabled} from 'features';

class WaterAnalysis extends React.Component {
  static propTypes = {
    analysis: PropTypes.object.isRequired,
    branch: PropTypes.object.isRequired,
    changeScanner: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    dataChanged: PropTypes.func.isRequired,
    dealer: PropTypes.object.isRequired,
    disabledFields: PropTypes.array,
    edit: PropTypes.bool.isRequired,
    handshakeComplete: PropTypes.bool.isRequired,
    group: PropTypes.object.isRequired,
    isType: PropTypes.func.isRequired,
    noScannersFound: PropTypes.bool.isRequired,
    pHBuffer: PropTypes.string.isRequired,
    pool: PropTypes.object.isRequired,
    prevAlgicide: PropTypes.string.isRequired,
    products: PropTypes.any.isRequired,
    sanitizerName: PropTypes.string.isRequired,
    sanitizerType: PropTypes.number.isRequired,
    isScanning: PropTypes.bool.isRequired,
    scanners: PropTypes.array.isRequired,
    scannerSettings: PropTypes.func.isRequired,
    selectedScanner: PropTypes.any,
    testers: PropTypes.array.isRequired,
    temperature: PropTypes.number,
    updateFocusElement: PropTypes.func.isRequired,
    useHTTPScannerInterface: PropTypes.bool,
    version: PropTypes.string,
    warningFieldIds: PropTypes.object,
    SLSAvailableFirmware: PropTypes.string,
    SLSMustUpdate: PropTypes.bool,
  };

  getWaterAnalysis = () => {
    const {country} = this.props.dealer;
    let analysis = this.props.analysis;
    let pool = this.props.pool;
    let {formatMessage} = this.props.intl;
    let all = [];



    if (this.props.analysis.season !== seasonTypes.closing && this.props.analysis.season !== seasonTypes.outSeason) {
      all.push(<TemperatureInput label={formatMessage({id: 'general.temperature'})}
                            analysis={analysis}
                            dealer={this.props.dealer}
                            pool={pool}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            group={this.props.group}
                            disabled={this.props.disabledFields}/>);
    }


    all.push(<LayoutInput label={formatMessage({id: 'analysis.total.dissolved.solids'})}
                          dataKey='tDS'
                          key='tDS'
                          value={analysis.tDS}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          group={this.props.group}
                          validate={val => !val || val >= 0 && val <= 9999}
                          validateMessage={<FormattedMessage id='analysis.validate.dissolved.solids' />}
                          type='number'
                          disabled={this.props.disabledFields}/>);

    all.push(<LayoutInput label={formatMessage({id: 'analysis.cya'})}
                          dataKey='cYA'
                          key='cYA'
                          warning={'warningFieldIds' in this.props && 'cYA' in this.props.warningFieldIds}
                          value={analysis.cYA}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 12, 13, 14, 15])}
                          type='number'
                          leaveBlank={true}
                          group={this.props.group}
                          required={!analysis.chlorineDemandOnly && pool.typeID !== systemTypes.spa}
                          validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 999}
                          validateMessage={<FormattedMessage id='analysis.validate.cya' />}
                          disabled={this.props.disabledFields}/>);

    if (this.props.isType([12, 13]) || this.props.sanitizerName === 'Saltwater Spa') {
      all.push(<LayoutInput label={formatMessage({id: 'general.salt'})}
                            dataKey='salt'
                            key='salt'
                            value={analysis.salt}
                            warning={'warningFieldIds' in this.props && 'salt' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            condition={this.props.isType([12, 13]) || this.props.sanitizerName === 'Saltwater Spa'}
                            required={true}
                            disabled={this.props.disabledFields}
                            type='number'
                            group={this.props.group}
                            validate={val => !val || val >= 0 && val <= 9999}
                            validateMessage={<FormattedMessage id='analysis.validate.salt' />}/>);
    } else {
      all.push(<LayoutInput label={formatMessage({id: 'general.minerals'})}
                            dataKey='minerals'
                            key='minerals'
                            value={analysis.minerals}
                            warning={'warningFieldIds' in this.props && 'mineral' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            leaveBlank={true}
                            group={this.props.group}
                            condition={this.props.isType([7])}
                            disabled={this.props.disabledFields}
                            type='number'
                            required={!analysis.chlorineDemandOnly}
                            validate={val => analysis.chlorineDemandOnly || !val || val >= 0 && val <= 9999}
                            validateMessage={<FormattedMessage id='analysis.validate.minerals' />}/>);
    }

    if (this.props.isType([1, 6])) {
      all.push(<LayoutInput label={formatMessage({id: 'general.total.bromine'})}
                            dataKey='totalBromine'
                            key='totalBromine'
                            warning={'warningFieldIds' in this.props && 'totalBromine' in this.props.warningFieldIds}
                            value={analysis.totalBromine}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            condition={this.props.isType([1, 6])}
                            group={this.props.group}
                            required={!analysis.chlorineDemandOnly}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 99}
                            type='number'
                            validateMessage={<FormattedMessage id='analysis.validate.total.bromine' />}
                            disabled={this.props.disabledFields}/>);
    } else if (this.props.isType([3])) {
      all.push(<LayoutInput label={formatMessage({id: 'general.softswim'}) + 'B'}
                            dataKey='sSWB'
                            key='sSWB'
                            warning={'warningFieldIds' in this.props && 'sSWB' in this.props.warningFieldIds}
                            value={analysis.sSWB}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            type='number'
                            disabled={this.props.disabledFields}
                            group={this.props.group}
                            required={!analysis.chlorineDemandOnly}
                            condition={this.props.isType([3])}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 100}
                            validateMessage={<FormattedMessage id='analysis.validate.softswim.b' />}/>);
    } else if (this.props.isType([8])) {
      all.push(<LayoutInput label={formatMessage({id: 'general.ssk.sanitizer'})}
                            dataKey='sSKSanitizerResidual'
                            key='sSKSanitizerResidual'
                            warning={'warningFieldIds' in this.props && 'sSKSanitizerResidual' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            condition={this.props.isType([8])}
                            type='number'
                            value={analysis.sSKSanitizerResidual}
                            required={!analysis.chlorineDemandOnly}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 100}
                            disabled={this.props.disabledFields}
                            validateMessage={<FormattedMessage id='analysis.validate.ssk.sanitizer' />}
                            group={this.props.group}/>);
    } else {
      all.push(<LayoutInput label={formatMessage({id: 'general.total.chlorine'})}
                            ref='totalChlorine'
                            dataKey='totalChlorine'
                            key='totalChlorine'
                            warning={'warningFieldIds' in this.props && 'totalChlorine' in this.props.warningFieldIds}
                            value={analysis.totalChlorine}
                            dataChanged={this.props.dataChanged}
                            group={this.props.group}
                            required={!analysis.chlorineDemandOnly}
                            editMode={this.props.edit}
                            condition={this.props.isType([2, 5, 7, 12, 13, 14, 15])}
                            disabled={this.props.disabledFields}
                            type='number'
                            leaveBlank={true}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 99 &&
                              (!analysis.freeChlorine || parseFloat(val) >= parseFloat(analysis.freeChlorine))}
                            validateMessage={<FormattedMessage id='analysis.validate.total.chlorine' />}/>);
    }

    if (this.props.isType([3])) {
      all.push(<LayoutInput label={formatMessage({id: 'general.softswim'}) + 'C'}
                            dataKey='sSWC'
                            key='sSWC'
                            value={analysis.sSWC}
                            warning={'warningFieldIds' in this.props && 'sSWC' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            type='number'
                            disabled={this.props.disabledFields}
                            group={this.props.group}
                            required={!analysis.chlorineDemandOnly}
                            condition={this.props.isType([3])}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 500}
                            validateMessage={<FormattedMessage id='analysis.validate.softswim.c' />}/>);
    } else if (this.props.isType([8])) {
      all.push(<LayoutInput label={formatMessage({id: 'general.ssk.shock'})}
                            dataKey='sSKShockResidual'
                            key='sSKShockResidual'
                            warning={'warningFieldIds' in this.props && 'sSKShockResidual' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            value={analysis.sSKShockResidual}
                            disabled={this.props.disabledFields}
                            group={this.props.group}
                            editMode={this.props.edit}
                            condition={this.props.isType([8])}
                            type='number'
                            required={!analysis.chlorineDemandOnly}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 500}
                            validateMessage={<FormattedMessage id='analysis.validate.ssk.shock' />}/>);
    } else {
      all.push(<LayoutInput label={formatMessage({id: 'general.free.chlorine'})}
                            dataKey='freeChlorine'
                            key='freeChlorine'
                            value={analysis.freeChlorine}
                            warning={'warningFieldIds' in this.props && 'freeChlorine' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            condition={this.props.isType([2, 5, 7, 12, 13, 14, 15])}
                            disabled={this.props.disabledFields}
                            type='number'
                            group={this.props.group}
                            required={!analysis.chlorineDemandOnly}
                            validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 99}
                            leaveBlank={true}
                            validateMessage={<FormattedMessage id='analysis.validate.free.chlorine' />}/>);
    }

    all.push(<LayoutInput label={formatMessage({id: 'general.ph'})}
                          dataKey='pH'
                          key='pH'
                          value={analysis.pH}
                          warning={'warningFieldIds' in this.props && 'pH' in this.props.warningFieldIds}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          validate={val => analysis.chlorineDemandOnly || (!!val || val === 0) && val >= 0 && val <= 14}
                          required={!analysis.chlorineDemandOnly}
                          validateMessage={<FormattedMessage id='analysis.validate.ph' />}
                          type='number'
                          group={this.props.group}
                          disabled={this.props.disabledFields}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.total.alkalinity'})}
                          dataKey='alkalinity'
                          key='alkalinity'
                          warning={'warningFieldIds' in this.props && 'alkalinity' in this.props.warningFieldIds}
                          value={analysis.alkalinity}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 999}
                          disabled={this.props.disabledFields}
                          type='number'
                          group={this.props.group}
                          required={!analysis.chlorineDemandOnly}
                          validateMessage={<FormattedMessage id='analysis.validate.total.alkalinity' />}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.calcium.hardness'})}
                          dataKey='hardness'
                          key='hardness'
                          warning={'warningFieldIds' in this.props && 'hardness' in this.props.warningFieldIds}
                          value={analysis.hardness}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 9999}
                          disabled={this.props.disabledFields}
                          type='number'
                          group={this.props.group}
                          required={!analysis.chlorineDemandOnly}
                          validateMessage={<FormattedMessage id='analysis.validate.calcium.hardness'/>}/>);

    const optLabel = optimizerPlusTitle(this.props.dealer, this.props.branch, pool, formatMessage);

    all.push(<LayoutInput label={optLabel}
                          dataKey='optimizerPlusBorate'
                          key='optimizerPlusBorate'
                          warning={'warningFieldIds' in this.props && 'optimizerPlusBorate' in this.props.warningFieldIds}
                          value={analysis.optimizerPlusBorate}
                          group={this.props.group}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          validate={val => !val || val >= 0 && val <= 100}
                          validateMessage={<FormattedMessage id='analysis.validate.optimizer.plus' values={{title: optLabel}}/>}
                          disabled={this.props.disabledFields}
                          type='number'
                          condition={pool.usingOptimizerPlus && !this.props.isType([14, 15])}/>);

    all.push(<LayoutInput label={formatMessage({id: 'analysis.initiator'})}
                          dataKey='initiatorLevel'
                          key='initiatorLevel'
                          value={analysis.initiatorLevel}
                          group={this.props.group}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          disabled={this.props.disabledFields}
                          validate={val => !val || val >= 0 && val <= 99}
                          validateMessage={<FormattedMessage id='analysis.validate.initiator'/>}
                          type='number'
                          condition={this.props.isType([14, 15])}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.copper'})}
                          dataKey='copper'
                          key='copper'
                          warning={'warningFieldIds' in this.props && 'copper' in this.props.warningFieldIds}
                          value={analysis.copper}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          type='number'
                          group={this.props.group}
                          validate={val => !val || val >= 0 && val <= 99}
                          disabled={this.props.disabledFields}
                          validateMessage={<FormattedMessage id='analysis.validate.copper' />}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'analysis.copper.smart'})}
                             dataKey='copperFromProduct'
                             key='copperFromProduct'
                             value={analysis.copperFromProduct}
                             editMode={this.props.edit}
                             disabled={this.props.disabledFields}
                             group={this.props.group}
                             condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15]) && !!analysis.copper && analysis.copper > 0 && analysis.copper < 1 &&
                             (pool.typeID === systemTypes.pool || pool.typeID === systemTypes.swimspa)}
                             dataChanged={this.props.dataChanged}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.iron'})}
                          dataKey='iron'
                          key='iron'
                          warning={'warningFieldIds' in this.props && 'iron' in this.props.warningFieldIds}
                          value={analysis.iron}
                          editMode={this.props.edit}
                          dataChanged={this.props.dataChanged}
                          validate={val => !val || val >= 0 && val <= 99}
                          type='number'
                          group={this.props.group}
                          validateMessage={<FormattedMessage id='analysis.validate.iron'/>}
                          disabled={this.props.disabledFields}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.quat'})}
                          dataKey='quat'
                          key='quat'
                          value={analysis.quat}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13]) && this.props.prevAlgicide !== 'Banish' &&
                          (pool.typeID === systemTypes.pool || pool.typeID === systemTypes.swimspa)}
                          validate={val => !val || val >= 0 && val <= 99}
                          type='number'
                          group={this.props.group}
                          validateMessage={<FormattedMessage id='analysis.validate.quat'/>}
                          disabled={this.props.disabledFields}/>);

    all.push(
      <LayoutCheckbox label={this.props.sanitizerType === 8 ? formatMessage({id: 'analysis.fresh.soft'}) : formatMessage({id: 'analysis.fresh.fill'})}
                      dataKey='freshFill'
                      key='freshFill'
                      value={analysis.freshFill}
                      dataChanged={this.props.dataChanged}
                      editMode={this.props.edit}
                      condition={(analysis.season !== seasonTypes.closing)}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'general.startup'})}
                             dataKey='startup'
                             key='startup'
                             value={analysis.startup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([7])}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'analysis.startup.trio'})}
                             dataKey='trioStartup'
                             key='trioStartup'
                             value={analysis.trioStartup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={pool.softSoakTRIO}/>);

    all.push(
      <LayoutCheckbox label={formatMessage({id: 'analysis.temp'}) + (country === countries.CA ? ' < 0' : ' < 32')}
                      dataKey='tempLT32'
                      key='tempLT32'
                      value={analysis.tempLT32}
                      dataChanged={this.props.dataChanged}
                      editMode={this.props.edit}
                      condition={analysis.season === seasonTypes.closing}/>);

    all.push(
      <LayoutCheckbox label={formatMessage({id: 'analysis.plaster'}) + ' < 30 ' + formatMessage({id: 'general.days'})}
                      dataKey='plasterLT30Days'
                      key='plasterLT30Days'
                      value={analysis.plasterLT30Days}
                      dataChanged={this.props.dataChanged}
                      editMode={this.props.edit}
                      condition={(pool.finish === 'W' || pool.finish === 'C') && analysis.season !== seasonTypes.closing}/>);

    all.push(
      <LayoutCheckbox label={formatMessage({id: 'analysis.plaster'}) + ' < 12 ' + formatMessage({id: 'general.months'})}
                      dataKey='plasterLT12Months'
                      key='plasterLT12Months'
                      value={analysis.plasterLT12Months}
                      dataChanged={this.props.dataChanged}
                      editMode={this.props.edit}
                      condition={(pool.finish === 'W' || pool.finish === 'C') &&
                      analysis.season === seasonTypes.closing}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'analysis.clean.drain'})}
                             dataKey='cleanAndDrain'
                             key='cleanAndDrain'
                             value={analysis.cleanAndDrain}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([5, 6, 8, 13, 15])}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'analysis.spa.sentry.startup'})}
                             dataKey='spaSentryStartup'
                             key='spaSentryStartup'
                             value={analysis.spaSentryStartup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([5, 6, 13, 15]) && this.props.pHBuffer === 'Spa Sentry'}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'general.manganese'})}
                             dataKey='manganese'
                             key='manganese'
                             value={analysis.manganese}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}/>);

    const showPhosphateCondition = country === countries.US ?
      analysis.season !== seasonTypes.closing :
      analysis.season !== seasonTypes.closing && pool.typeID !== systemTypes.spa;

    all.push(<LayoutInput label={formatMessage({id: 'analysis.phosphate'})}
                            dataKey='phosphate'
                            key='phosphate'
                            value={analysis.phosphate}
                            warning={'warningFieldIds' in this.props && 'phosphate' in this.props.warningFieldIds}
                            dataChanged={this.props.dataChanged}
                            editMode={this.props.edit}
                            condition={showPhosphateCondition}
                            validate={val => !val || val >= 0 && val <= 9999}
                            type='number'
                            group={this.props.group}
                            validateMessage={<FormattedMessage id='analysis.validate.phosphate'/>}
                            disabled={this.props.disabledFields}/>);

    return balanceColumns(all, 4);
  };

  temperatureValidation = (val) => {
    const {country} = this.props.dealer;
    const {typeID} = this.props.pool;
    const {season} = this.props.analysis;

    if (country === countries.CA) {
      return validateTemperatureCelsius(val, typeID, season);
    }

    return validateTemperatureFarenheit(val, typeID, season);
  };

  temperatureValidationMessage = () => {
    return (() => {
      const {country} = this.props.dealer;
      const {season} = this.props.analysis;
      const {typeID} = this.props.pool;
      const temperatureModifier = country === countries.CA ? 'celsius' : 'farenheit';

      if (country === countries.CA) {

        if (typeID === systemTypes.swimspa) {
          return <FormattedMessage id='analysis.analysis.swimspas.celsius'/>;
        }
        if (typeID === systemTypes.spa) {
          return <FormattedMessage id='analysis.analysis.spas.celsius'/>;
        }

        if (season === seasonTypes.inSeason) {
          return <FormattedMessage id={'analysis.analysis.inSeason.' + temperatureModifier}/>;
        }

        return season === seasonTypes.opening ?
          <FormattedMessage id={'analysis.analysis.springOpening.' + temperatureModifier}/> : '';
      }

      if (country === countries.US) {
        if (!(typeID === systemTypes.pool || typeID === systemTypes.swimspa)) {
          return <FormattedMessage id='analysis.analysis.spas.farenheit'/>;
        }

        if (season === seasonTypes.inSeason) {
          return <FormattedMessage id={'analysis.analysis.inSeason.' + temperatureModifier}/>;
        }

        return season === seasonTypes.opening ?
          <FormattedMessage id={'analysis.analysis.springOpening.' + temperatureModifier}/> : '';
      }

    })();
  };

  render() {
    if (this.props.SLSMustUpdate) {
      return <div className='row'>
        <div className='col-xs-12'>
          <h2><FormattedMessage id="general.water.analysis"/></h2>
          <FirmwareRequired
          SLSAvailableFirmware={this.props.SLSAvailableFirmware}/>
        </div>
      </div>;
    }

    let {formatMessage} = this.props.intl;
    let testerLayoutSelect =
      <LayoutSelect label={formatMessage({id: 'general.tester'})}
                    editMode={true}
                    dataChanged={this.props.dataChanged}
                    dataKey='waterTester'
                    keys={this.props.testers.map(t => t.name)}
                    options={this.props.testers.map(t => t.name)}
                    validateMessage={<FormattedMessage id='analysis.select.name.tester'/>}
                    group={this.props.group}
                    required={true}
                    validate={value => value !== formatMessage({id: 'scanning.select.tester'})}
                    value={this.props.analysis.waterTester}/>;

    let waterAnalysis = this.props.pool ? this.getWaterAnalysis() : [];

    let scannerErrors;

    if (this.props.noScannersFound) {
      scannerErrors = <p className='error'>{getErrorCode(11005, formatMessage)}</p>;
    }

    let seasonKeys = ['springopening', 'in', 'winterclosing'];
    let seasonOptions = [
      formatMessage({id: 'general.season.springopening'}),
      formatMessage({id: 'general.season.in'}),
      formatMessage({id: 'general.season.winterclosing'}),
    ];

    if (this.props.products) {
      let winterizers = this.props.products.filter(p => p.productTypeID === productTypes.winterOxidizer);
      let hasDoesNotCloseWinterizer = winterizers ? winterizers.filter(w => w.code === winterOxidizers.doesNotClose &&
        w.id === this.props.pool.winterOxidizer).length >= 1 : false;

      if (this.props.pool.typeID === systemTypes.swimspa || hasDoesNotCloseWinterizer) {
        //remove winterclosing
        seasonKeys.pop();
        seasonOptions.pop();
      }
      if (hasDoesNotCloseWinterizer) {
        seasonKeys.push('out');
        seasonOptions.push(formatMessage({id: 'general.season.out'}));
      }
    }
    let tcStatusBar = !!this.props.useHTTPScannerInterface ?
      <TestConnectStatusBar2p0 showBorder={true} hideXFInventory={true} /> :
      <TestConnectStatusBar showBorder={true}/>;

    return <div className='row'>
      <div className='col-xs-12'>
        <h2><FormattedMessage id="general.water.analysis"/></h2>
        {testConnectSidebarEnabled ? tcStatusBar : null}
        <div className='analysis-body'>
          <div className='row'>
          <div className='col-md-3'>
            {testerLayoutSelect}
          </div>
          {this.props.pool.typeID !== systemTypes.spa ?
            <div className='col-md-3'>
              <LayoutSelect label='Season'
                            editMode={true}
                            dataChanged={this.props.dataChanged}
                            value={this.props.analysis.season}
                            dataKey='season'
                            options={seasonOptions}
                            keys={seasonKeys}/>
            </div> :
            null}
          <div className='col-md-3'>
            <div className='form-group'>
              <label>
                <FormattedMessage id="general.test.method"/>
                <ToolTip title={formatMessage({id: 'analysis.test.connection.running'}) +
                (this.props.version ? ' ' + formatMessage({id: 'analysis.currently.using.test'}) + ': ' + this.props.version : '')}
                         position={tooltipPositions.topRight}
                         iconOnly/>
              </label>
              <Loader loaded={this.props.handshakeComplete}>
                <select className='form-control'
                        id='test123'
                        title={formatMessage({id: 'analysis.device.drop.down'})}
                        value={this.props.selectedScanner}
                        onChange={this.props.changeScanner}
                        disabled={this.props.isScanning}>
                  {this.props.scanners.map(scanner => {
                    let scannerName = '';
                    let isOptionDisabled = false;

                    if (scanner === 'Accuscan') {
                      scannerName = 'AccuScan II';
                    } else if (scanner === 'SmartLab' || scanner === 'SmartLab 1') {
                      scannerName = 'Smart Lab 1';
                    } else if (scanner && (scanner.toString().indexOf('Spin Touch') >= 0 || scanner === 'SmartLab 2')) {
                      scannerName = 'Smart Lab 2';
                    } else if (scanner.toLowerCase() === 'manual') {
                      scannerName = formatMessage({id: 'general.manual'});
                    } else {
                      scannerName = scanner;
                    }

                    // Disable AccuFlex™ option if Soft Swim sanitizer type
                    if (scannerName === xfName && [chemicalBaseTypes.softswimPool, chemicalBaseTypes.softSoakSpa].indexOf(this.props.sanitizerType) !== -1) {
                      isOptionDisabled = true;
                    }

                    return <option key={scanner}
                      value={scanner}
                      disabled={isOptionDisabled}>{scannerName}</option>;
                  })}
                </select>
              </Loader>
            </div>
          </div>
          {this.props.pool.typeID === systemTypes.spa ? <div className='col-md-3'/> : null}
          {!testConnectSidebarEnabled ? <div className='col-md-3'>
            {scannerErrors}
          </div> : null}
          {this.props.scannerSettings()}
        </div>
          <div className='col-md-12'>
            <h3><FormattedMessage id="general.water.properties"/></h3>
            <hr/>
          </div>
          {waterAnalysis}
          <div className='col-md-12'>
            <h3>
              <FormattedMessage id="general.cleaning.information"/>
              <ToolTip title={formatMessage({id: 'analysis.inputting.last.cleaning'})}
                       position={tooltipPositions.topRight}
                       iconOnly/>
            </h3>
            <hr/>
          </div>
          <div>
            <div className='col-sm-3'>
              <LayoutDatePicker data-event-category='User'
                                data-event-action='date-filter-clean'
                                dataKey='filterCleanedDate'
                                dateFormat='D MMMM YYYY'
                                key='filterCleanedDate'
                                value={this.props.analysis.filterCleanedDate}
                                onChange={this.props.dataChanged}
                                editMode={this.props.edit}
                                title={formatMessage({id: 'analysis.insert.date.customer'})}
                                label={formatMessage({id: 'analysis.filter.cleaned.date'})}/>
            </div>
            {this.props.isType([7, 12]) ? <div className='col-sm-3'>
              <LayoutDatePicker dateFormat='D MMMM YYYY'
                                onChange={this.props.dataChanged}
                                editMode={this.props.edit}
                                dataKey='mSCellCleanedDate'
                                key='mSCellCleanedDate'
                                label={formatMessage({id: 'analysis.cell.cleaned.date'})}
                                value={this.props.analysis.mSCellCleanedDate}
              />
            </div> : null}
            {this.props.isType([5, 6, 8, 13]) && !this.props.pool.softSoakTRIO ?
              <div className='col-sm-3'>
                <LayoutDatePicker label={formatMessage({id: 'analysis.last.cleaned.drained'})}
                                  dataKey='lastCleanedDrained'
                                  key='lastCleanedDrained'
                                  value={this.props.analysis.lastCleanedDrained}
                                  onChange={this.props.dataChanged}
                                  editMode={this.props.edit}
                                  title={formatMessage({id: 'analysis.insert.cleaned.drained'})}
                                  data-event-category='User'
                                  data-event-action='date-cleaned-drained'
                                  dateFormat='D MMMM YYYY'/>
              </div> : null}
          </div>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(WaterAnalysis);
